import { Modal } from 'antd';
import { IoClose } from 'react-icons/io5';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { ViewerMode } from '../../../config';
import { PageViewer } from '../../Canvas/PageViewer';

const ImageModel = observer(() => {
    const { viewManager } = useMainContext();

    return (
        <Modal
            className="image-popup-modal  w-full h-[90vh]  "
            width={'80%'}
            height={'95vh'}
            centered
            onCancel={() => viewManager.setModelOpen(false)}
            footer={null}
            closable={false}
            open={viewManager.modelOpen}>
            <div className="review-popup-modal-content flex flex-col gap-[24px]">
                <div className="flex justify-between items-center w-full h-[36px]">
                    <h2 className="text-[16px] font-medium text-[#858585] leading-5">
                        {viewManager.imageData?.name}
                    </h2>
                    <button
                        className="review-popup-modal-close-button"
                        onClick={() => viewManager.setModelOpen(false)}>
                        <IoClose className="w-[24px] h-[24px] text-[#858585]" />
                    </button>
                </div>
                <div className="flex justify-center items-center w-full h-full">
                    <PageViewer viewerMode={ViewerMode.VIEW} />
                </div>
            </div>
        </Modal>
    );
});

export default ImageModel;
